<style scoped>
.button-wrapper {
    max-width: 7rem;
}
button.selected {
    @apply bg-primary;
}

button {
    border-color: rgb(149, 194, 167) !important;
}
</style>

<template>
    <div class="flex flex-row justify-between">
        <div
            v-for="(o, oi) in options"
            :key="oi"
            class="flex-1 flex flex-col items-center sm:mr-1 button-wrapper"
        >
            <button
                @click="e => click(e, o)"
                :disabled="status"
                class="w-full border-darkGrayishBlue border-2 rounded focus:outline-none py-1"
                :class="{ selected: selectedSlctKey === o.id }"
            >
                <div
                    v-if="status === 'loading' && selectedSlctKey === o.id"
                    class="flex items-center justify-center"
                >
                    <spinner class="spinner-sm" />
                </div>
                <template v-else>
                    {{ $t(o.slctDesp) }}
                </template>
            </button>
            <div
                class="text-center"
                v-if="oi === 0 || oi === options.length - 1"
            >
                {{ oi === 0 ? '最低' : '最高' }}
            </div>
        </div>
    </div>
</template>

<script>
import { instance } from '@/utils/ajax';
import spinner from '@/components/spinner.vue';

async function submitProdRate(prodFdbkEmailTknNum, prodFdbkSlctKey) {
    try {
        let result = await instance.post(
            '/api/productFeedback/submitProdRate',
            {
                prodFdbkEmailTknNum,
                prodFdbkSlctKey
            }
        );
        return result.data;
    } catch (e) {
        /*eslint-disable no-console*/
        console.error('error submitProdRate');
    }
    return undefined;
}

async function submitProdRcmd(prodFdbkEmailTknNum, prodFdbkSlctKey) {
    try {
        let result = await instance.post(
            '/api/productFeedback/submitProdRcmd',
            {
                prodFdbkEmailTknNum,
                prodFdbkSlctKey
            }
        );
        return result.data;
    } catch (e) {
        /*eslint-disable no-console*/
        console.error('error submitProdRate');
    }
    return undefined;
}

export default {
    components: { spinner },
    props: {
        prodFdbkEmailTknNum: { type: String, required: true },
        slctKey: { required: true },
        options: { type: Array, required: true },
        feedbackType: { type: String, required: true }
    },
    data() {
        return {
            status: this.slctKey ? 'submitted' : undefined,
            selectedSlctKey: undefined
        };
    },
    created() {
        this.$watch(
            'slctKey',
            function(v) {
                this.selectedSlctKey = v;
            },
            { immediate: true }
        );
    },
    methods: {
        async click(event, feedbackOption) {
            this.status = 'loading';
            this.selectedSlctKey = feedbackOption.id;

            const result =
                this.feedbackType === 'ProductRate'
                    ? await submitProdRate(
                          this.prodFdbkEmailTknNum,
                          feedbackOption.id
                      )
                    : await submitProdRcmd(
                          this.prodFdbkEmailTknNum,
                          feedbackOption.id
                      );

            if (result && result.success) {
                const elDomRect = event.target.getBoundingClientRect();
                this.$emit('slctKey', feedbackOption.id);
                this.$emit('submitted', elDomRect);
                this.status = 'submitted';
            } else {
                this.selectedSlctKey = undefined;
                this.status = undefined;
            }
        }
    }
};
</script>
